import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLandingsComponent } from './user-landings.component';
import { UserLandingCardComponent } from './user-landing-card/user-landing-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from "../eva-button/eva-button.module";
import { EvaMessageModule } from "../eva-message/eva-message.module";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EvaTabsModule } from '@shopping-angular-components/eva-tabs';

@NgModule({
    declarations: [
        UserLandingsComponent,
        UserLandingCardComponent
    ],
    exports: [
        UserLandingsComponent,
        UserLandingCardComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        EvaButtonModule,
        EvaMessageModule,
        BrowserAnimationsModule,
        EvaTabsModule,
    ]
})
export class UserLandingsModule { }
